import { render, staticRenderFns } from "./DoctorReviewsDesktop.vue?vue&type=template&id=2fbe625e&"
import script from "./DoctorReviewsDesktop.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DoctorReviewsDesktop.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fbe625e')) {
      api.createRecord('2fbe625e', component.options)
    } else {
      api.reload('2fbe625e', component.options)
    }
    module.hot.accept("./DoctorReviewsDesktop.vue?vue&type=template&id=2fbe625e&", function () {
      api.rerender('2fbe625e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/pressa/components/desktop/DoctorReviewsDesktop.vue"
export default component.exports